export const DIALOG_PAPER_SX = { width: 600, maxHeight: '80%', margin: 0 } as const;
